import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconAdd: React.FC<IconProps> = ({ width = 13, height = 13, color = '#DFEAFF' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 13 13"
            fill="none"
        >
            <g clip-path="url(#clip0_13112_4540)">
                <path
                    d="M6.50195 13C6.3336 13 6.17215 12.9331 6.05311 12.8141C5.93406 12.695 5.86719 12.5336 5.86719 12.3652V0.634766C5.86719 0.466415 5.93406 0.30496 6.05311 0.185919C6.17215 0.0668769 6.3336 0 6.50195 0C6.6703 0 6.83176 0.0668769 6.9508 0.185919C7.06984 0.30496 7.13672 0.466415 7.13672 0.634766V12.3652C7.13672 12.5336 7.06984 12.695 6.9508 12.8141C6.83176 12.9331 6.6703 13 6.50195 13Z"
                    fill="black"
                />
                <path
                    d="M12.3652 7.13477H0.634766C0.466415 7.13477 0.30496 7.06789 0.185919 6.94885C0.0668769 6.82981 0 6.66835 0 6.5C0 6.33165 0.0668769 6.17019 0.185919 6.05115C0.30496 5.93211 0.466415 5.86523 0.634766 5.86523H12.3652C12.5336 5.86523 12.695 5.93211 12.8141 6.05115C12.9331 6.17019 13 6.33165 13 6.5C13 6.66835 12.9331 6.82981 12.8141 6.94885C12.695 7.06789 12.5336 7.13477 12.3652 7.13477Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_13112_4540">
                    <rect width="13" height="13" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconAdd;
